var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',_vm._b({ref:"myCascader",style:({ width: _vm.width ? `${_vm.width}px` : '100%' }),attrs:{"options":_vm.options,"props":{ expandTrigger: 'hover' }},on:{"change":_vm.handleChange},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}},'el-cascader',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }